import { useUser } from '@clerk/nextjs';
import { Home, PlusCircle, Settings, Users } from 'lucide-react';
import { useMemo } from 'react';
import { LinkRouter } from '@/code/lib/routes';
import type { PageItem } from '../types';

/**
 * Hook to get the appropriate page navigation items based on
 * whether user belongs to an organization.
 */
export function useRegularUserPages(): PageItem[] {
  const { user } = useUser();
  const orgSlug = user?.organizationMemberships?.[0]?.organization.slug;

  return useMemo(() => {
    // Organization user
    if (orgSlug) {
      return [
        {
          label: 'Home',
          href: LinkRouter.routeForOrganizationHome(orgSlug),
          icon: Home,
          keywords: ['dashboard'],
        },
        {
          label: 'Personal',
          href: LinkRouter.routeForOrganizationPersonalPage(orgSlug),
          icon: Users,
          keywords: ['my', 'dashboard'],
        },
        {
          label: 'Create Campaign',
          href: LinkRouter.routeForOrganizationNewCampaign(orgSlug),
          icon: PlusCircle,
          keywords: ['new', 'add'],
        },
        {
          label: 'Settings',
          href: LinkRouter.routeForUserSettings(),
          icon: Settings,
        },
      ];
    }

    // Non-organization user
    return [
      {
        label: 'Dashboard',
        href: LinkRouter.routeForDashboard(),
        icon: Home,
        keywords: ['home'],
      },
      {
        label: 'Create Campaign',
        href: LinkRouter.routeForDataEntry(),
        icon: PlusCircle,
        keywords: ['new', 'add', 'entry'],
      },
      {
        label: 'Settings',
        href: LinkRouter.routeForUserSettings(),
        icon: Settings,
      },
    ];
  }, [orgSlug]);
}
